var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca :href=\"agencyLink\" target=\"_blank\"\u003E{{ agencyName }}\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;